import { render } from "./HorizontalBasic.vue?vue&type=template&id=3c90071d&scoped=true"
import script from "./HorizontalBasic.vue?vue&type=script&lang=js"
export * from "./HorizontalBasic.vue?vue&type=script&lang=js"

import "./HorizontalBasic.vue?vue&type=style&index=0&id=3c90071d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c90071d"]])

export default __exports__